import { TextFieldProps } from '@mui/material';

export const defaultTextFieldProps: Partial<TextFieldProps> = {
  margin: 'none',
  fullWidth: true,
  variant: 'outlined',
  size: 'small',
  onKeyDown: (event) => {
    // prevent MUI keyboard accessibility features to allow for full input editing capabilities
    event.stopPropagation();
  },
};
